import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  ArticlesWithEligibleCreativesQuery,
  ArticlesWithEligibleCreativesQueryVariables
} from './__generated__/ArticlesWithEligibleCreativesQuery';
import {
  ArticlesWithDiscountSettingsQueryVariables,
  ArticlesWithDiscountSettingsQuery
} from './__generated__/ArticlesWithDiscountSettingsQuery';

export const ARTICLES_WITH_ELIGIBLE_CREATIVES_QUERY = gql`
  query ArticlesWithEligibleCreativesQuery($filter: AllArticlesFilterInput, $limit: Int) {
    allArticles(filter: $filter, limit: $limit) {
      edges {
        node {
          id
          eligibleCreatives {
            id
          }
          eligibleCreativesWithoutAds {
            id
            iframe
          }
        }
      }
    }
  }
`;

export const ALL_ARTICLES_WITH_DISCOUNT_SETTINGS = gql`
  query ArticlesWithDiscountSettingsQuery($filter: AllArticlesFilterInput) {
    allArticles(filter: $filter) {
      edges {
        node {
          id
          title
          discountSettings {
            id
            enabled
            discountType
            discountValue
          }
        }
      }
    }
  }
`;

export const useArticlesWithEligibleCreativesLazyQuery = () => {
  return useLazyQuery<ArticlesWithEligibleCreativesQuery, ArticlesWithEligibleCreativesQueryVariables>(
    ARTICLES_WITH_ELIGIBLE_CREATIVES_QUERY,
    { client: kmsClient, fetchPolicy: 'cache-first', notifyOnNetworkStatusChange: true }
  );
};

export const useArticlesWithDiscountSettingsLazyQuery = () => {
  return useLazyQuery<ArticlesWithDiscountSettingsQuery, ArticlesWithDiscountSettingsQueryVariables>(
    ALL_ARTICLES_WITH_DISCOUNT_SETTINGS,
    { client: kmsClient, fetchPolicy: 'network-only', notifyOnNetworkStatusChange: true }
  );
};
